export default {
  short_description: 'Gagnez du temps & récoltez des récompenses !',
  full_description:
    "L'application {{name}} est là – pour commander encore plus facilement :\n\n• Commande ultra-rapide via l'app\n\n• Notifications immédiates sur les promotions et récompenses\n\n• Cumulez et utilisez vos points facilement\n\n• Suivez le statut de votre commande en temps réel\n\nNous sommes ravis de vous offrir notre app – et espérons que vous l'apprécierez autant que nous !`",
};
